var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveStepIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5V0.5L4.66667 4.30952L0 8.5Z",
    fill: "#00E2D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 8.5V0.5L9.33333 4.30952L4.66667 8.5Z",
    fill: "#00E2D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 8.5V0.5L14 4.30952L9.33333 8.5Z",
    fill: "#00E2D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStepIcon);
export default __webpack_public_path__ + "static/media/ActiveStepIcon.822da28655533917c9802edd3ab6f8fe.svg";
export { ForwardRef as ReactComponent };